var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7967 0H2.20329C1.61894 0 1.05853 0.247607 0.645329 0.688351C0.232132 1.12909 0 1.72687 0 2.35018V13.6498C0 14.2731 0.232132 14.8709 0.645329 15.3116C1.05853 15.7524 1.61894 16 2.20329 16H12.7967C13.3811 16 13.9415 15.7524 14.3547 15.3116C14.7679 14.8709 15 14.2731 15 13.6498V2.35018C15 1.72687 14.7679 1.12909 14.3547 0.688351C13.9415 0.247607 13.3811 0 12.7967 0ZM0.881316 6.58049H5.2879V10.3596H0.881316V6.58049ZM6.16921 6.58049H14.1187V10.3596H6.16921V6.58049ZM14.1187 2.35018V5.64042H6.16921V0.94007H12.7967C13.1473 0.94007 13.4836 1.08863 13.7315 1.35308C13.9794 1.61753 14.1187 1.97619 14.1187 2.35018ZM2.20329 0.94007H5.2879V5.64042H0.881316V2.35018C0.881316 1.97619 1.02059 1.61753 1.26851 1.35308C1.51643 1.08863 1.85268 0.94007 2.20329 0.94007ZM0.881316 13.6498V11.2996H5.2879V15.0599H2.20329C1.85268 15.0599 1.51643 14.9114 1.26851 14.6469C1.02059 14.3825 0.881316 14.0238 0.881316 13.6498ZM12.7967 15.0599H6.16921V11.2996H14.1187V13.6498C14.1187 14.0238 13.9794 14.3825 13.7315 14.6469C13.4836 14.9114 13.1473 15.0599 12.7967 15.0599Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.67480706c9fb4a52f64a15782a1c91f8.svg";
export { ForwardRef as ReactComponent };